import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';
import { initialItem } from './addNewSection';
import { findTemplateSectionIndex } from '../utils/nameUniqueness';

export interface Payload {
  name: string;
  layoutType: LayoutType;
  tabId?: string | null;
}

export const resetSection = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType, tabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = findTemplateSectionIndex(sections, name, tabId);

  if (sectionIndex === -1) return;

  state[layoutType].sections[sectionIndex] = {
    ...sections[sectionIndex],
    sizeX: 1,
    sizeY: 1,
    subTabs: null,
    items: [{ ...initialItem, subTabId: null }],
  };
};
